import { Button as ButtonAntd, Card as CardAntd } from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 5px 5px !important;
  }
`;

export const EditarButton = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  background: #74aa49;
  border-radius: 4px !important;
  padding: 8px 20px;

  &:hover {
    background: #add290;
    border-color: #add290;
    color: #fff;
  }

  &:focus {
    background: #5c8839;
    border-color: #5c8839;
    color: #fff;
  }
`;
